import { useSelector, useDispatch } from 'react-redux'
import { REDUX_PROMPT_TYPES } from 'tennders-common/stores/prompt/action'
import { apiPost } from 'tennders-stracture/libs/api'
import { useToast } from 'tennders-common/hooks/useToast'
import useTranslation from 'next-translate/useTranslation'

const useTruckPlates = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { toastSuccess, toastError } = useToast()
  const transaction = useSelector((state) => state.prompt.updatePlates)

  const updatePlateNumbers = (transaction) => dispatch({
    type: REDUX_PROMPT_TYPES.UPDATE_PLATES,
    payload: transaction
  })

  const requestPlates = async (transaction) => {
    const res = await apiPost(`/transactions/${transaction?.id}/request-plate-update`)
    if (res?.result) {
      toastSuccess(t('toast:emailSent'))
    } else {
      toastError(res?.error)
    }
  }

  return {
    updatePlateNumbers,
    transaction,
    requestPlates
  }
}

export default useTruckPlates
